(() => {
  const params = new URLSearchParams(location.search);
  const model = (params.get('modele') || '').slice(0, 160).trim();
  const context = document.querySelector('[data-bz-advice-context]');
  if (!model || !context) return;
  document.getElementById('bz-contact-model').value = model;
  document.getElementById('bz-contact-options').value = (params.get('options') || '').slice(0, 200);
  const path = params.get('fiche') || '';
  const variant = params.get('variante') || '';
  // Only record local product paths; query parameters never become HTML.
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(path)) {
    const productUrl = new URL(path, location.origin);
    if (/^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
    document.getElementById('bz-contact-product-link').value = productUrl.href;
  }
  context.hidden = false;
})();
